import { Box, useTheme } from "@mui/material";
import * as React from "react";

import { CommentsBox } from "@/shared/components/CommentsBox/CommentsBox";
import { CommentEntityType } from "@/shared/domain/comments";
import { FileRecord } from "@/shared/domain/files";

import { useWorkspaceFiles } from "../WorkspaceCtx";

export function WorkspaceComment() {
  const theme = useTheme();
  const files = useWorkspaceFiles();

  const commentEntity = React.useMemo(() => getCommentEntity(files), [files]);

  if (!commentEntity) {
    return null;
  }

  return (
    <Box
      sx={{
        marginTop: theme.spacing(2),
        px: theme.spacing(1),
      }}
    >
      <CommentsBox
        entityType={commentEntity.entityType}
        entityId={commentEntity.entityId}
        enableTimestamps={true}
      />
    </Box>
  );
}

/**
 * If a single file is selected, the comment entity is the file.
 * If multiple files are selected, but all are from the same dataset,
 * the comment entity is the dataset.
 *
 * Otherwise, there is no comment entity.
 */
function getCommentEntity(files: FileRecord[]): {
  entityType: CommentEntityType;
  entityId: string;
} | null {
  if (files.length === 0) {
    return null;
  }

  if (files.length === 1) {
    return {
      entityType: "file",
      entityId: files[0].file_id,
    };
  }

  const allSameDataset = files.every(
    (file) => file.association_id === files[0].association_id,
  );

  if (allSameDataset) {
    return {
      entityType: "dataset",
      entityId: files[0].association_id,
    };
  }

  return null;
}
